import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import DetailCard from "../components/detailCard"
import "./detail.scss"

const DetailPage = ({ data }) => {
  const post = data.microcmsPost
  return (
    <Layout>
      <SEO
        title={`${post.title}の書評`}
        description={`${post.title}の書評。ITベンチャーで働く20代の読書記録です。ビジネススキル、Web開発に関する技術書、UIデザインについての書籍を紹介することが多いです。`}
        meta={[
          {
            property: `og:image`,
            content: post.image.url,
          },
        ]}
      />
      <section className="detailPage">
        <div className="detailPage-card-wrapper">
          <DetailCard
            key={post.id}
            id={post.id}
            imageUrl={post.image.url}
            amazonUrl={post.amazonUrl}
            kindleUrl={post.kindleUrl}
            title={post.title}
            summary={post.summary}
            createdAt={post.createdAt}
          />
        </div>
        <div className="detailPage-content-list">
          {post.content1 && (
            <p className="detailPage-content">{post.content1}</p>
          )}
          {post.content2 && (
            <p className="detailPage-content">{post.content2}</p>
          )}
          {post.content3 && (
            <p className="detailPage-content">{post.content3}</p>
          )}
          {post.content4 && (
            <p className="detailPage-content">{post.content4}</p>
          )}
          {post.content5 && (
            <p className="detailPage-content">{post.content5}</p>
          )}
        </div>
      </section>
    </Layout>
  )
}

export default DetailPage

export const query = graphql`
  query($id: String) {
    microcmsPost(id: { eq: $id }) {
      id
      title
      summary
      image {
        url
      }
      amazonUrl
      kindleUrl
      content1
      content2
      content3
      content4
      content5
      createdAt(formatString: "YYYY年MM月DD日")
    }
  }
`
